export const ANY_NON_DIGIT_REGEX= /[^0-9]/g
export const CELL_FORMATTER_REGEX = /^(\d\d)(\d{1})(\d{4})(\d{4}).*/
export const CELL_FORMATTER_REGEX_NOT_DD = /^(\d{1})(\d{4})(\d{4}).*/
export const PHONE_FORMATTER_REGEX = /\(\d{2}\)\s\d{4}\-\d{4}/g //eslint-disable-line
export const PHONE_REGEX = /\d{10}/g
export const CELL_REGEX = /\d{11}/g
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9-]+\.?([a-z]?)+/
export const DATE_BR_REGEX = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
